/** Recover approximate text ink/background colors from PDF.js' rendered pixels.
 * This is more reliable than assuming all imported text is dark on white.
 * Return colours in #rrggbb suitable for both the browser and export. */
function median(values) {
  if (!values.length) return 255;
  const sorted=[...values].sort((a,b)=>a-b);
  return sorted[Math.floor(sorted.length/2)];
}
function hex(rgb) { return '#'+rgb.map(v=>Math.max(0,Math.min(255,Math.round(v))).toString(16).padStart(2,'0')).join(''); }
export function inferTextColors(pixels,width,height) {
  if (!pixels || width<2 || height<2) return {color:'#20242c',background:'#ffffff',contrast:0};
  const values=[];
  const boundary=[];
  const step=Math.max(1,Math.floor(Math.min(width,height)/50));
  for(let y=0;y<height;y+=step)for(let x=0;x<width;x+=step){
    const k=(y*width+x)*4;
    const c=[pixels[k],pixels[k+1],pixels[k+2]];
    values.push(c);
    if(x<Math.max(2,step*2) || y<Math.max(2,step*2) ||
      x>width-Math.max(3,step*3) || y>height-Math.max(3,step*3)) boundary.push(c);
  }
  const background=[0,1,2].map(i=>median(boundary.map(c=>c[i])));
  // The most different opaque pixels within the glyph box represent ink. Using
  // the upper contrast quantile is robust to subpixel anti-aliasing artifacts.
  const ranked=values.map(c=>({c,delta:Math.max(...c.map((v,i)=>Math.abs(v-background[i])))}))
    .sort((a,b)=>b.delta-a.delta);
  const sample=ranked.slice(0,Math.max(1,Math.ceil(ranked.length*0.12)))
    .filter(v=>v.delta>=20);
  const color=sample.length ? [0,1,2].map(i=>median(sample.map(v=>v.c[i]))) :
    (background.reduce((a,b)=>a+b,0)/3<128 ? [255,255,255]:[35,35,35]);
  return {color:hex(color),background:hex(background),contrast:Math.round(ranked[0]?.delta || 0)};
}
